import { FlywheelDefaultCardAction } from '../../../behaviors/flywheel/default/FlywheelDefaultCardAction';
import { FlywheelDefaultChickletHoverActions } from '../../../behaviors/flywheel/default/FlywheelDefaultChickletHoverActions';
import { CardAction, ChickletHoverActions } from '../../../constants/BehaviorTypes';
export const FlywheelDefault = {
  [CardAction]: () => FlywheelDefaultCardAction,
  [ChickletHoverActions]: () => FlywheelDefaultChickletHoverActions
};